import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const CalloutContainer = styled.div<{ showPointer: boolean }>`
  display: flex;
  width: 100%;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-top: ${(props) =>
    `1px solid ${props.theme.atlas.semantic.color.action.primary.hover}`};
  border-bottom: ${(props) =>
    `1px solid ${props.theme.atlas.semantic.color.action.primary.hover}`};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  padding: 8px 20px;
  cursor: ${(props) => (props.showPointer ? 'pointer' : 'default')};
`;
